import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { SearchDropdownComponent } from './search-dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    StopPropagationModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    MatSelectModule,
    MatOptionModule,
  ],
  exports: [SearchDropdownComponent],
  declarations: [SearchDropdownComponent],
})
export class SearchDropdownModule {}
